import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const requestedAreasApi = {
  getRequestedAreas: async (filters: any = {}) => {
    const { search, city, page = 1, limit = 50, sortBy = "createdAt", sortOrder = "desc" } = filters;
    let url = `${API_URL}/api/admin/requested-areas?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (city) {
      url += `&city=${encodeURIComponent(city)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getRequestedAreaById: async (requestedAreaId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/requested-areas/${requestedAreaId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getRequestedAreasStats: async () => {
    const response = await axios.get(`${API_URL}/api/admin/requested-areas/stats`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getRequestedAreasCities: async () => {
    const response = await axios.get(`${API_URL}/api/admin/requested-areas/cities`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  deleteRequestedArea: async (requestedAreaId: string) => {
    const response = await axios.delete(
      `${API_URL}/api/admin/requested-areas/${requestedAreaId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },
};

export default requestedAreasApi; 